module.exports = __webpack_public_path__ + "static/beats-web-c09541565df1c6dbef8acb7fd32131dd.jpg";